import {Provider} from "@angular/core";
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";
import {CiBasicConfigPage} from "../page/overview/ci-basic-config/ci-basic-config.page";
import {
    CiContractInsurableObjectComponent
} from "../component/protected-components/ci-contract-insurable-object-component/ci-contract-insurable-object.component";
import {
    CiContractPersonComponent
} from "../component/protected-components/ci-contract-person-component/ci-contract-person.component";
import {
    CiSearchFlexibleInsuranceComponent
} from "../search/ci-search-flexible-insurance/ci-search-flexible-insurance.component";
import {CrCustomerCreatePage} from "../../cr/page/object/cr-customer-create/cr-customer-create.page";


const ciModuleEntry: TestModuleDefinition = {
    key: 'ci',
    label: 'Contract Insurable (ci)',
    components: [
        {
            key: 'CiContractInsurableObjectComponent',
            component: CiContractInsurableObjectComponent,
            selector: 'ci-insurable-object',
            type: 'ObjectBaseComponent',
            label: 'ci contract insurable object component'
        },
        {
            key: 'CiContractPersonComponent',
            component: CiContractPersonComponent,
            selector: 'ci-contract-person',
            type: 'ObjectBaseComponent',
            label: 'ci contract person component'
        },
        {
            key: 'BasicConfigPage',
            component: CiBasicConfigPage,
            selector: 'mvs-ci-basic-config',
            type: 'PageComponent',
            label: 'basic config page'
        },
        {
            key: 'CrCustomerCreatePage',
            component: CrCustomerCreatePage,
            selector: 'mvs-cr-create-customer-page',
            type: 'PageComponent',
            label: 'Customer Create Page'
        },
        {
            key: 'CiSearchFlexibleInsuranceComponent',
            component: CiSearchFlexibleInsuranceComponent,
            selector: 'ci-search-flexible-insurance',
            type: 'Component',
            label: 'ci search flexible insurance component'
        }
    ]
}

export const CI_TEST_PROVIDERS: Provider[] = [
    {provide: TEST_MODULE_REGISTRY, useValue: ciModuleEntry, multi: true}
];